import { setRoomHidden, undoRoomHidden } from '@/api/setRoomHidden'
import Icon from '@/assets/icons'
import classNames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { MouseEvent, useState } from 'react'
import { useMutation } from 'react-query'
import styles from './style.module.scss'

const cx = classNames.bind(styles)

const LiveFeedVisibilitySwitch = ({ initialVisibility = false, roomId }: { initialVisibility?: boolean; roomId: string }) => {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState<boolean>(initialVisibility)
  const hideRoomMutation = useMutation(setRoomHidden)
  const unHideRoomMutation = useMutation(undoRoomHidden)

  const toggleSwitch = async (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    setIsVisible(!isVisible)
    const action = isVisible ? hideRoomMutation : unHideRoomMutation
    try {
      await action.mutateAsync({
        roomId,
      })
    } catch (error) {
      setIsVisible((prev) => !prev)
    }
  }

  return (
    <div className={cx('visibility-switch', { isVisible })} onClick={toggleSwitch}>
      <div className={cx('visibility-switch__icon')}>{isVisible ? <Icon.EyeOpen_HollowEyeball /> : <Icon.EyeClose_Wide />}</div>
      <p className={cx('visibility-switch__text')}>{isVisible ? t('My_Live_Public_Livestream') : t('My_Live_Private_Livestream')}</p>
    </div>
  )
}

export default LiveFeedVisibilitySwitch
